<template>
  <section class="page-search-form">
    <div class="search-label">证书编号:</div>
    <div class="search-input">
      <el-input
        v-model.trim="certNo"
        clearable=""
        placeholder="请输入证书编号"
        class="custom-input">
        <el-button
          slot="append"
          @click="getidentificationcertbyno">查询</el-button>
      </el-input>
    </div>
    <cert-file-modal ref="modal" />

    <el-image-viewer
      v-if="showViewer"
      :z-index="9999"
      :on-close="closeViewer"
      :url-list="srcList" />
  </section>
</template>
<script>
import CertFileModal from '../cert-file-modal/cert-file-modal.vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue'
import { instance } from '../../axios'
export default {
  name: 'PageSearchForm',
  components: { CertFileModal, ElImageViewer },
  data() {
    return { certNo: '', showViewer: false, srcList: [] } // ZJ1721008669
  },
  methods: {
    getidentificationcertbyno() {
      const certNo = this.certNo
      if (certNo) {
        instance
          .get(`v1/luxurycert/getcoursecertbyno`, { params: { certNo: this.certNo }})
          .then(res => {
            const { result, message, certFile } = res.data
            if (result === 0) {
              this.openViewer(certFile)
            } else {
              this.$message.error(message)
            }
          })
          .catch(error => {
            this.$message.error(error.message)
          })
      } else {
        this.$message.error('请输入正确的证书编号')
      }
    },
    openViewer(url) {
      this.srcList = [url]
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>
<style lang="stylus" scoped src="./page-search-form.styl"></style>
